import { useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const RESULT_TEXT = {
  reconciled: 'Wompi confirmó la transferencia. Se registró su identificador y el desembolso pasó a «Enviado». No se movió dinero.',
  not_found: 'Wompi no tiene ninguna transferencia con esta referencia. No se hizo ningún reintento ni se movió dinero.',
  indeterminate: 'No fue posible confirmar el estado en Wompi. El desembolso sigue retenido; no se movió dinero.',
};

export const PayoutSafeReconcileButton = ({ payoutId, onDone }) => {
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/payouts/${payoutId}/safe-reconcile`);
      setRes(data);
      if (data.result === 'reconciled') onDone?.();
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === 'string' ? d : 'No se pudo consultar Wompi');
    } finally { setBusy(false); }
  };
  return (
    <>
      <button onClick={run} disabled={busy} data-testid={`admin-payout-safe-reconcile-${payoutId}`}
        className="mt-1 inline-flex items-center gap-1 text-xs text-emerald-700 hover:underline disabled:opacity-50">
        <ShieldCheck className="h-3 w-3" /> {busy ? 'Consultando Wompi…' : 'Reintento seguro'}
      </button>
      <Dialog open={!!res} onOpenChange={(o) => !o && setRes(null)}>
        <DialogContent className="rounded-none sm:max-w-lg" data-testid="admin-payout-safe-reconcile-dialog">
          <DialogHeader><DialogTitle>Conciliación con Wompi</DialogTitle></DialogHeader>
          {res && (
            <div className="space-y-2 text-sm">
              <p data-testid="admin-payout-safe-reconcile-result">{RESULT_TEXT[res.result]}</p>
              <div className="font-mono text-xs text-slate-600">Referencia consultada: {res.evidence?.wompi_reference}</div>
              {res.gateway_transaction_id && <div className="font-mono text-xs">ID Wompi: {res.gateway_transaction_id}</div>}
              {res.evidence?.reason && <div className="font-mono text-xs text-slate-600">Motivo: {res.evidence.reason}</div>}
              <pre className="max-h-48 overflow-auto bg-slate-50 p-2 text-[10px]">{JSON.stringify(res.evidence?.raw ?? {}, null, 2)}</pre>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};
